import {gsap} from "gsap";
import {SplitText} from "gsap/SplitText";
gsap.registerPlugin(SplitText)

let throttle_handler = null;
let projectListWrapper = null;
let images_projects_list = null;
let first_timeOut = null;
let tweens_array = [];
let tween_mask = null;
const zIndexFrontImage = 4;
const zIndexBackImage = 2;

/**
 * Return the parents div for the projects list
 * @returns {Element}
 */
const get_projects_list_el = (container) => container.querySelector('#projects-list');


/**
 * Delete dot separator at the end of each line
 */
const toggle_dot_in_project_list = () => {
     // console.log("calcul");
    const li_array = projectListWrapper.querySelectorAll("li");
    const li_length = li_array.length;

    // on test chaque li du menu en regardant le prochain li
    li_array.forEach((item, index, array) => {
        if(index < li_length-1){
            const item_position = item.getBoundingClientRect();
            const nextItem = array[index + 1];
            const item_next_position = nextItem.getBoundingClientRect();
            if(item_next_position.top > item_position.top){
                item.classList.add('no-separator');
            }else{
                item.classList.remove('no-separator');
            }
        }
    })
}

/**
 * switch the img_index in front of the view
 * @param img_index
 */
const switch_zindex_image = (img_index) => {
    images_projects_list.forEach((picture, index) => {
        if(index === parseInt(img_index)){
            gsap.set(picture, {alpha:0})
            picture.style.zIndex = zIndexFrontImage;
            gsap.to(picture, {alpha:1, duration:.5, ease:"power1.out", onComplete:hideProjectImages, onCompleteParams:[false]});

        }else{
            picture.style.zIndex = zIndexBackImage;
        }
    });
}

/**
 * Hide project picture
 * @param allImages Hide all picture (true) ou only the backgrounded image
 */
const hideProjectImages = (allImages = true)  => {
    images_projects_list.forEach((picture, index) => {
        if(allImages){

            gsap.set(picture, {alpha:0})
        }else{
            if(parseInt(picture.style.zIndex) !== zIndexFrontImage){
                gsap.set(picture, {alpha:0})
            }
        }
    });
    if(allImages){
        // On enlève le mixblend mode sur le header et le year copyright
        const year = document.querySelector("#year-copy");
        const header = document.querySelector("#main-header");
        year.classList.remove("no-mix-blend");
        header.classList.remove("no-mix-blend");
    }
}


/**
 *  Initialisation des liens sur les noms de projets
 *  - Duplication des noms de sprojet pour l'effet d'animation
 *  - Définition des tween d'animation
 *  - Ajout des listeners
 */
const  duplicate_project_name = ()  => {

    const links_array = projectListWrapper.querySelectorAll("li a");

    // on split les lettres et mots des noms des projets
    new SplitText(links_array, {type:"chars, words", wordsClass:'word', charsClass: "char"})

    // on duplique le nom des projets
    links_array.forEach((item, index)=> {
        const project_name_wrappper = item.firstElementChild,
                project_name_ref = project_name_wrappper.firstElementChild,
                 clone = project_name_ref.cloneNode(true);
         clone.classList.remove("ref");
         clone.classList.add("clone");
        project_name_ref.after(clone);

        tweens_array[index] = [];
        //definition des tweens pour les mots et lettre du projet
        const words_ref = project_name_ref.querySelectorAll(".word");
        words_ref.forEach((word_ref) => {
            const letter_of_word = word_ref.querySelectorAll('.char');
            const  tween = gsap.to(letter_of_word, { y:-58, duration:0.3, ease:"power1.out",alpha:0, stagger: 0.02, paused:true});
            tweens_array[index].push(tween);
        })
        //definition des tweens pour les mots et lettre du clone du projet
        const words_clone = clone.querySelectorAll(".word");
        words_clone.forEach((word_clone) => {
            const  letter_of_word = word_clone.querySelectorAll('.char');
            const  tween = gsap.to(letter_of_word, { y:0, duration:0.3, ease:"power1.out",alpha:1, stagger: 0.02, paused:true});
            tweens_array[index].push(tween);
        })

        addListeners(item);
    })

    // Définition du tween pour le mask des visuels
    tween_mask = gsap.to("#project_image_mask", {width:"80%",duration:0.5,delay:0,paused:true, ease:"power3.out", onReverseComplete:hideProjectImages})
}

/**
 * Add mouseenter and mouseleave listener
 * @param link The project link
 */
const addListeners = (link) => {
    link.addEventListener("mouseenter", enterHandler);
    link.addEventListener("mouseleave", leaveHandler);
}

/**
 * Remove mouseenter and mouseleave listener
 * @param link The project link
 */
const removeListeners = (link) => {
    link.removeEventListener("mouseenter", enterHandler);
    link.removeEventListener("mouseleave", leaveHandler);
}


const enterHandler = (e) => {
    projectListWrapper.classList.add('play-down-dot');
    // play tweens for the project name
    const current_link = e.target,
        link_index = current_link.dataset.loopindex,
        project_color = current_link.dataset.projectcolor,
        tweens = tweens_array[link_index];
    tweens.forEach((tween) => tween.play())

    // on passe l'imaeg correspondante au premier plan et on l'affiche
    switch_zindex_image(link_index);

    // on change la couleur de fond
     gsap.to('body, #project_image_mask', {duration:.75,ease: "power1.easeInOut", backgroundColor:project_color, delay:.2});

    // downplay other projects names
    const links_array = projectListWrapper.querySelectorAll("li a");
    links_array.forEach((link)=> {
        if(link !== current_link){
            gsap.to(link, {alpha:.5,duration:0.5,delay:0, ease:"power1.out"});
        }
    })

    // On enlève le mixblend mode sur le header et le year copyright
    const year = document.querySelector("#year-copy");
    const header = document.querySelector("#main-header");
    year.classList.add("no-mix-blend");
    header.classList.add("no-mix-blend");


    tween_mask.play();

}
const leaveHandler = (e) => {
    projectListWrapper.classList.remove('play-down-dot');
    // play tweens for the project name
    const current_link = e.target,
        link_index = current_link.dataset.loopindex,
        tweens = tweens_array[link_index];
    tweens.forEach((tween) => tween.reverse())

    // on change la couleur de fond
    gsap.to('body, #project_image_mask', {duration:0.75,ease: "power1.easeInOut", backgroundColor:"#000000", delay:.2});

    // hightlight all projects names
    const links_array = projectListWrapper.querySelectorAll("li a");
    links_array.forEach((link)=> {
        if(link !== current_link){
            gsap.to(link, {alpha:1,duration:0.5,delay:0, ease:"power1.out"});
        }
    })
    tween_mask.reverse();


}

/**
 * Initialization of project list
 * @param container
 */
const projects_list_init = (container) => {
    projectListWrapper = get_projects_list_el(container);
    if( projectListWrapper ){
        // console.log("projects_list_init");
        // Duplicate project name
        duplicate_project_name()

        images_projects_list = container.querySelectorAll('#project_images_list picture')

       // Lance l'écouteur pour les toggle séparator'
       //  throttle_handler = throttle(toggle_dot_in_project_list.bind(this, elem), 100);
        window.addEventListener('resize', toggle_dot_in_project_list);
        toggle_dot_in_project_list();
        first_timeOut = setTimeout(toggle_dot_in_project_list, 200);
    }
}

/**
 * Desinitialization of project list
 */
const projects_list_desinit = () => {
    if( projectListWrapper ){
        // console.log("projects_list_desinit");
        clearTimeout(first_timeOut);
        first_timeOut = null;
        window.removeEventListener('resize',  toggle_dot_in_project_list);
        throttle_handler = null;

        const links_array = projectListWrapper.querySelectorAll("li a");
        links_array.forEach((item)=> {
            removeListeners(item);
        })

        tween_mask = null;
        images_projects_list = null;
    }
}

export {projects_list_init, projects_list_desinit};